import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAUTH_ENDPOINT } from '@core/const';
import { BadRequestHandler, GlobalMessageType } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class CustomBadRequestHandler extends BadRequestHandler {
  protected handleBadPassword(request: HttpRequest<any>, response: HttpErrorResponse): void {
    if (
      response.url?.includes(OAUTH_ENDPOINT) &&
      response.error?.error === 'invalid_grant' &&
      request.body?.get('grant_type') === 'password'
    ) {
      this.globalMessageService.add(
        {
          key: 'httpHandlers.badRequestPleaseLoginAgain',
          params: {
            errorMessage: 'Неправильный код',
          },
        },
        GlobalMessageType.MSG_TYPE_ERROR,
      );
      this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION);
    }
  }
}
